import React, { Component } from "react";

import { state } from "./statesList";

import {
  checkEmpanelementStatus,
  saveNpsBasicDetails,
  saveNpsBankDetails,
  getRejectionDetails,
  saveRejectionDetails,
} from "../../../store/actions/nps";
import { getProfileData } from "../../../store/actions/profile";
import Signbutton from "../../forms/button";
import { Input } from "../../forms/input";
import IntegrationReactSelect from "../../forms/autoCompleteInput";
import { connect } from "react-redux";
import { MenuItem, Paper } from "@material-ui/core";
import { HDFC_POP_CODE, ICICI_POP_CODE, NPS_URL } from "./index";
import * as POP_CONSTANTS from "./index";
import CustomLoader from "../../forms/Loader";
import { SucesssPopUp } from "../customModal";
import CustomizedSelect from "../transactions/customizedSelect";

const IS_REJECTED = 3003;
const NOT_REGISTERED = 2002;

class NpsBasicDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Arn: "",
      Bank: { value: "" },
      Name: { value: "" },
      PAN: { value: "" },
      Email_Id: { value: "" },
      MobileNo: { value: "" },
      Address: { value: "" },
      City: { value: "" },
      State: { value: "" },
      Pincode: { value: "" },
      Address2: { value: "" },
      City2: { value: "" },
      State2: { value: "" },
      Pincode2: { value: "" },
      Experience: { value: "" },
      Customers: { value: "" },
      Modal: false,
      Loading: false,
      EmpanelmentStatus: "",
      RejectionBank: "",
      sameAddress: false,
      RejectionMessage: "",
    };
  }
  async componentDidMount() {
    const Arn = this.props.token.replace("ARN-", "");
    const diff = 8 - Arn.length;
    const ArnNumber = "0".repeat(diff) + Arn;
    this.setState({ Loading: true });
    await this.props.getProfileData({
      Agent: this.props.token,
      UserId: this.props.userId,
    });
    const { Distributor_Name, MobileNo, PAN, Email } = this.props.profileData;
    const AgentReferenceNumber = PAN + ArnNumber;
    const Details = this.props.Nps_Basic_Details || {};
    if (PAN[3] === "C") {
      this.setState({
        Loading: false,
        PAN: {
          value: PAN,
        },
      });
      return;
    }
    this.setState({
      Name: { value: Distributor_Name },
      PAN: { value: PAN },
      Email_Id: {
        value: !!Details.Email ? Details.Email : !!Email ? Email : "",
      },
      MobileNo: {
        value: !!Details.MobileNo
          ? Details.MobileNo
          : !!MobileNo
          ? MobileNo
          : "",
      },
      Arn: ArnNumber,
      Address: { value: Details.Address || "" },
      City: { value: Details.City || "" },
      State: { value: Details.State || "" },
      Pincode: { value: Details.Pincode || "" },
      Address2: { value: Details.Address2 || "" },
      Bank: { value: Details.Bank || "" },
      City2: { value: Details.City2 || "" },
      State2: { value: Details.State2 || "" },
      Pincode2: { value: Details.Pincode2 || "" },
      Experience: { value: Details.Experience || "" },
      Customers: { value: Details.Customers || "" },
    });

    const popMap = {
      Hdfc: {},
      Icici: {},
      Aditya: {},
    };

    const popList = Object.keys(popMap).map((pk) => {
      const pop = popMap[pk];

      pop.POP_CodeKey = pop.POP_CodeKey || `${pk.toUpperCase()}_POP_CODE`;
      pop.POP_SP_CodeKey =
        pop.POP_SP_CodeKey || `${pk.toUpperCase()}_POP_SP_CODE`;

      return pop;
    });

    try {
      // Putting all api calls in a list
      const apiRequests = popList.map((pop) => {
        const reqBody = {
          AgentReferenceNumber: AgentReferenceNumber,
          POP_Code: POP_CONSTANTS[pop.POP_CodeKey],
          POP_SP_Code: POP_CONSTANTS[pop.POP_SP_CodeKey],
        };
        return this.props.checkEmpanelementStatus(reqBody);
      });

      const responses = await Promise.allSettled(apiRequests);
      const isAnyRejected = responses.find((response) => {
        const statusCode = parseInt(JSON.parse(response.value.body).Code);
        return statusCode === IS_REJECTED;
      });

      // Store status of POP if user is registered in any of them.
      let registeredPOP_Status;
      responses.forEach((response) => {
        const statusCode = parseInt(JSON.parse(response.value.body).Code);

        if (statusCode > 3000 && statusCode !== IS_REJECTED) {
          registeredPOP_Status = statusCode;
        }
      });
      const isAnyRegistered = !!registeredPOP_Status;

      // If any of them is rejected
      if (isAnyRejected) {
        const response = await this.props.getRejectionDetails({
          AgentReferenceNumber: AgentReferenceNumber,
        });
        const body = JSON.parse(response.body);
        const AgentDetails = body.AgentDetails[0];
        const {
          AEM_Name,
          AEM_PAN,
          AEM_Email_ID,
          AEM_MobileNo,
          AEM_RegisteredAddress,
          AEM_RegisteredAddressCity,
          AEM_RegisteredAddressState,
          AEM_RegisteredAddressPincode,
          AEM_CorrespondenceAddress,
          AEM_CorrespondenceAddressCity,
          AEM_CorrespondenceAddressState,
          AEM_CorrespondenceAddressPincode,
          AEM_NO_Experience,
          AEM_NO_Customers,
          AEM_RejectedRemarks,
          AEM_BankAccountNumber,
          AEM_BankIFSC,
          AEM_BankName,
          AEM_BankBranch,
          AEM_POP_Code,
        } = AgentDetails;
        const CorrespondenceState = state.find(
          (e) => e[1] === AEM_CorrespondenceAddressState
        );
        const RegisteredState = state.find(
          (e) => e[1] === AEM_RegisteredAddressState
        );
        const State = {
          label: CorrespondenceState[0],
          value: CorrespondenceState[1],
        };
        const State2 = {
          label: !!RegisteredState ? RegisteredState[0] : "",
          value: !!RegisteredState ? RegisteredState[1] : "",
        };
        this.setState({
          Name: { value: AEM_Name },
          PAN: { value: AEM_PAN },
          Email_Id: { value: AEM_Email_ID },
          MobileNo: { value: AEM_MobileNo },
          Address: { value: AEM_CorrespondenceAddress },
          City: { value: AEM_CorrespondenceAddressCity },
          State: { value: State },
          Pincode: { value: AEM_CorrespondenceAddressPincode },
          Address2: { value: AEM_RegisteredAddress },
          City2: { value: AEM_RegisteredAddressCity },
          State2: { value: State2 },
          Pincode2: { value: AEM_RegisteredAddressPincode },
          Experience: { value: AEM_NO_Experience },
          Customers: { value: AEM_NO_Customers },
          RejectionMessage: AEM_RejectedRemarks,
          RejectionBank:
            AEM_POP_Code === HDFC_POP_CODE
              ? "HDFC"
              : AEM_POP_Code === ICICI_POP_CODE
              ? "ICICI"
              : "Aditya Birla",
        });
        const BankDetails = {
          AccountNumber: AEM_BankAccountNumber,
          IFSC: AEM_BankIFSC,
          BankName: AEM_BankName,
          Branch: AEM_BankBranch,
        };
        await this.props.saveNpsBankDetails(BankDetails);
        this.setState({
          Loading: false,
          Modal: true,
          EmpanelmentStatus: NOT_REGISTERED,
        });
      }
      // Hide the form when user is registered in any one of the  POPs
      else if (isAnyRegistered) {
        this.setState({
          EmpanelmentStatus: registeredPOP_Status,
          Loading: false,
        });
      }
      // If not registered, set status and show form
      else {
        this.setState({ EmpanelmentStatus: NOT_REGISTERED, Loading: false });
      }
    } catch (e) {
      alert(e);
    }
  }
  handlePOPChange = (event) => {
    this.setState({
      Bank: { value: event.target.value },
    });
  };
  handleChange = (label) => (event) => {
    this.setState({
      [label]: { value: event.target.value },
    });
  };
  handleRStateSelect = (value) => {
    this.setState({
      State2: { value: value },
    });
  };
  handleCStateSelect = (value) => {
    this.setState({
      State: { value: value },
    });
  };
  showError = (label) => (event) => {
    const value = event.target.value;
    if (!value) {
      this.setState({
        [label]: {
          value,
          isError: true,
          errorMessage:
            label === "MobileNo"
              ? "Mobile Number is Mandatory*"
              : label === "Email_Id"
              ? "Email ID is Mandatory*"
              : label === "Address"
              ? "Address is Mandatory*"
              : label === "City"
              ? "City is Mandatory*"
              : label === "State"
              ? "State is Mandatory*"
              : label === "Pincode"
              ? "Pincode is Mandatory*"
              : label === "Experience"
              ? "Please Enter Years of Experience*"
              : label === "Customers"
              ? "Number of Customers is Mandatory*"
              : "",
        },
      });
    } else {
      switch (label) {
        case "Email_Id":
          if (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(value)) {
            this.setState({
              [label]: {
                value: "",
                isError: true,
                errorMessage: "Enter a valid Email ID",
              },
            });
          }
          break;
        case "MobileNo":
          if (
            !/^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6-9]\d{9}$/.test(value)
          ) {
            this.setState({
              [label]: {
                value: "",
                isError: true,
                errorMessage: "Enter a valid Mobile Number",
              },
            });
          }
          break;
        case "Pincode":
          if (!/^[1-9][0-9]{5}$/.test(value)) {
            this.setState({
              [label]: {
                value: "",
                isError: true,
                errorMessage: "Enter a valid Mobile Number",
              },
            });
          }
          break;
        case "Pincode2":
          if (!/^[1-9][0-9]{5}$/.test(value)) {
            this.setState({
              [label]: {
                value: "",
                isError: true,
                errorMessage: "Enter a valid Mobile Number",
              },
            });
          }
          break;
        default:
          break;
      }
    }
  };
  submit = async () => {
    const {
      Modal,
      Loading,
      State2,
      City2,
      Address2,
      Pincode2,
      Arn,
      RejectionBank,
      RejectionMessage,
      EmpanelmentStatus,
      sameAddress,
      ...others
    } = this.state;
    const keys = Object.keys(others);
    const findError = keys.every((key) => !!others[key].value);
    if (!findError) {
      keys.forEach((key) => {
        const isNull = !others[key].value;
        if (isNull) {
          this.setState({
            [key]: {
              ...others[key],
              isError: true,
              errorMessage:
                key === "MobileNo"
                  ? "Mobile Number is Mandatory*"
                  : key === "Email_Id"
                  ? "Email ID is Mandatory*"
                  : key === "Address"
                  ? "Address is Mandatory*"
                  : key === "City"
                  ? "City is Mandatory*"
                  : key === "State"
                  ? "State is Mandatory*"
                  : key === "Pincode"
                  ? "Pincode is Mandatory*"
                  : key === "Experience"
                  ? "Please Enter Years of Experience* "
                  : key === "Customers"
                  ? "Number of Customers is Mandatory*"
                  : key === "Bank"
                  ? "Please select a Pension Fund to empanel with"
                  : "",
            },
          });
        }
      });
      return;
    } else if (
      !!this.state.PAN.value &&
      !/[A-Z]{5}[0-9]{4}[A-Z]{1}/.test(this.state.PAN.value)
    ) {
      this.setState({
        PAN: {
          value: this.state.PAN.value,
          isError: true,
          errorMessage: "Enter a Valid PAN Number",
        },
      });
      return;
    } else if (
      !!this.state.Email_Id.value &&
      !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
        this.state.Email_Id.value
      )
    ) {
      this.setState({
        Email_Id: {
          value: this.state.Email_Id.value,
          isError: true,
          errorMessage: "Enter a Valid Email Id",
        },
      });
      return;
    } else if (
      !!this.state.MobileNo.value &&
      !/^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6-9]\d{9}$/.test(
        this.state.MobileNo.value
      )
    ) {
      this.setState({
        MobileNo: {
          value: this.state.MobileNo.value,
          isError: true,
          errorMessage: "Enter a Valid Mobile Number",
        },
      });
      return;
    } else {
      const Arn = this.props.token.replace("ARN-", "").replace(" ", "");
      const diff = 8 - Arn.length;
      const ArnNumber = "0".repeat(diff) + Arn;
      const BasicDetails = {
        Name: this.state.Name.value,
        Arn: ArnNumber,
        PAN: this.state.PAN.value,
        Email_Id: this.state.Email_Id.value,
        MobileNo: this.state.MobileNo.value,
        Bank: this.state.Bank.value,
        Address: this.state.Address.value,
        City: this.state.City.value,
        State: this.state.State.value,
        Pincode: this.state.Pincode.value,
        City2: this.state.City2.value,
        State2: this.state.State2.value,
        Address2: this.state.Address2.value,
        Pincode2: this.state.Pincode2.value,
        Experience: this.state.Experience.value,
        Customers: this.state.Customers.value,
      };
      const RejectionDetails = {
        RejectionBank: this.state.RejectionBank,
        RejectionMessage: this.state.RejectionMessage,
      };
      this.props.saveNpsBasicDetails(BasicDetails);
      this.props.saveRejectionDetails(RejectionDetails);
      this.props.history.push(NPS_URL + "/onlineEmpanelement/bankDetails");
    }
  };
  render() {
    const { PAN, RejectionBank, RejectionMessage } = this.state;
    const Banks = [
      { label: "Aditya Birla Pension", value: "ADITYA" },
      { label: "HDFC Pension", value: "HDFC" },
      { label: "ICICI Prudential Pension Fund", value: "ICICI" },
    ];
    return (
      <div className="container-margin">
        <CustomLoader display={this.state.Loading} />
        <SucesssPopUp
          closeSucessModal={() => {
            this.setState({ Modal: false });
          }}
          response={
            `Your application was rejected by ${RejectionBank} for the reason :` +
            RejectionMessage
          }
          open={this.state.Modal}
          isNps={true}
          fail={true}
        />
        <div className="customer-support-email">
          Customer Support Email :{" "}
          <a href="mailto:npsdistributorsupport@kfintech.com">
            npsdistributorsupport@kfintech.com
          </a>
        </div>
        {PAN.value[3] === "C" ||
        this.state.EmpanelmentStatus !== NOT_REGISTERED ? (
          <div className="nps-head">
            Distribute National Pension System to your customers
          </div>
        ) : (
          ""
        )}
        {this.state.PAN.value[3] === "C" && (
          <div style={{ padding: "40px", margin: "40px", textAlign: "center" }}>
            <h4>
              As per PFRDA Circular, only IFA's are allowed to be NPS agents
            </h4>
          </div>
        )}
        {this.state.EmpanelmentStatus === 3002 && (
          <div style={{ padding: "40px", margin: "40px", textAlign: "center" }}>
            <h4>
              Your Empanelment Registration is Pending, Please contact your POP
              for further details
            </h4>
          </div>
        )}
        {this.state.EmpanelmentStatus === 3004 && (
          <div style={{ padding: "40px", margin: "40px", textAlign: "center" }}>
            <h4>
              Your Empanelment Registration is Inactive, Please contact your POP
              for further details
            </h4>
          </div>
        )}
        {this.state.EmpanelmentStatus === 3005 && (
          <div style={{ padding: "40px", margin: "40px", textAlign: "center" }}>
            <h4>
              Your Empanelment Registration is Onhold, Please contact your POP
              for further details
            </h4>
          </div>
        )}
        {this.state.EmpanelmentStatus === NOT_REGISTERED &&
          this.state.PAN.value[3] !== "C" && (
            <React.Fragment>
              {!!RejectionBank && (
                <div className="nps-rejected-message">
                  {`Your application was rejected by ${RejectionBank} for the reason :` +
                    RejectionMessage}
                </div>
              )}
              <div className="investor-title">Online Empanelment</div>
              <Paper className="digital-form-container">
                <div className="digital-form-Right-div-for-nps">
                  <div
                    className="investor-title"
                    style={{
                      fontWeight: 450,
                      marginTop: 20,
                      marginBottom: 30,
                      marginLeft: 20,
                    }}
                  >
                    {" "}
                    Basic Details
                  </div>
                  <div className="transaction-details">
                    <div className="input-margin flex">
                      <div className="appbar-div dual-margin ">
                        <div className="input-name input-responsive">Name*</div>
                        <div style={{ marginTop: 10 }}>
                          <Input
                            name=""
                            onChange={this.handleChange("Name")}
                            placeholder="Enter Name"
                            value={this.state.Name.value}
                            isError={this.state.Name.isError}
                            isShowError={this.state.Name.isError}
                            errorMessage={this.state.Name.errorMessage}
                            style={{ fontFamily: "OpenSans-Regular" }}
                            inputref={(ele) => (this.nameField = ele)}
                            onKeyDown={(e) =>
                              e.key === "Enter" && e.preventDefault()
                            }
                            disabled={true}
                          />
                        </div>
                      </div>
                      <div className="appbar-div dual-margin">
                        <div className="input-name input-responsive">PAN*</div>
                        <div style={{ marginTop: 10 }}>
                          <Input
                            name=""
                            onChange={this.handleChange("PAN")}
                            placeholder="Enter PAN No"
                            value={this.state.PAN.value}
                            isError={this.state.PAN.isError}
                            onKeyDown={(e) =>
                              e.key === "Enter" && e.preventDefault()
                            }
                            isShowError={this.state.PAN.isError}
                            errorMessage={this.state.PAN.errorMessage}
                            style={{ fontFamily: "OpenSans-Regular" }}
                            inputref={(ele) => (this.panField = ele)}
                            disabled={true}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="input-margin flex">
                      <div className="appbar-div dual-margin ">
                        <div className="input-name input-responsive">
                          Email*
                        </div>
                        <div style={{ marginTop: 10 }}>
                          <Input
                            name=""
                            onChange={this.handleChange("Email_Id")}
                            placeholder="Enter Email ID"
                            value={this.state.Email_Id.value}
                            isError={this.state.Email_Id.isError}
                            errorMessage={this.state.Email_Id.errorMessage}
                            onKeyDown={(e) =>
                              e.key === "Enter" && e.preventDefault()
                            }
                            isShowError={this.state.Email_Id.isError}
                            style={{ fontFamily: "OpenSans-Regular" }}
                            inputref={(ele) => (this.emailField = ele)}
                            onBlur={this.showError("Email_Id")}
                          />
                        </div>
                      </div>
                      <div className="appbar-div dual-margin ">
                        <div className="input-name input-responsive">
                          Mobile Number*
                        </div>
                        <div style={{ marginTop: 10 }}>
                          <Input
                            name=""
                            onChange={this.handleChange("MobileNo")}
                            placeholder="Enter Mobile Number"
                            value={this.state.MobileNo.value}
                            type="number"
                            onBlur={this.showError("MobileNo")}
                            onKeyDown={(e) =>
                              e.key === "Enter" && e.preventDefault()
                            }
                            isError={this.state.MobileNo.isError}
                            isShowError={this.state.MobileNo.isError}
                            errorMessage={this.state.MobileNo.errorMessage}
                            style={{ fontFamily: "OpenSans-Regular" }}
                            inputref={(ele) => (this.mobileField = ele)}
                          />
                        </div>
                      </div>
                    </div>
                    <br />
                    <div className="appbar-div dual-margin input-margin ">
                      <CustomizedSelect
                        name="POP"
                        handleChange={this.handlePOPChange}
                        value={this.state.Bank.value}
                        errorMessage={this.state.Bank.errorMessage}
                        isError={this.state.Bank.isError}
                        placeholder="Select POP"
                      >
                        {Banks.map((bank) => (
                          <MenuItem value={bank.value}>{bank.label}</MenuItem>
                        ))}
                      </CustomizedSelect>
                    </div>

                    <div className="input-margin flex">
                      <div className="appbar-div dual-margin">
                        <div className="input-name input-responsive">
                          No of Years of experience*
                        </div>
                        <div style={{ marginTop: 10 }}>
                          <Input
                            name=""
                            onChange={this.handleChange("Experience")}
                            placeholder="Enter no of years of experience"
                            value={this.state.Experience.value}
                            isError={this.state.Experience.isError}
                            isShowError={this.state.Experience.isError}
                            errorMessage={this.state.Experience.errorMessage}
                            onBlur={this.showError("Experience")}
                            onKeyDown={(e) =>
                              e.key === "Enter" && e.preventDefault()
                            }
                            style={{ fontFamily: "OpenSans-Regular" }}
                            type="number"
                            inputref={(ele) => (this.experienceField = ele)}
                          />
                        </div>
                      </div>
                      <div className="appbar-div dual-margin">
                        <div className="input-name input-responsive">
                          No of Customers*
                        </div>
                        <div style={{ marginTop: 10 }}>
                          <Input
                            name=""
                            onChange={this.handleChange("Customers")}
                            placeholder="Enter no of customers"
                            value={this.state.Customers.value}
                            isError={this.state.Customers.isError}
                            isShowError={this.state.Customers.isError}
                            errorMessage={this.state.Customers.errorMessage}
                            onBlur={this.showError("Customers")}
                            onKeyDown={(e) =>
                              (e.key === "Enter" || e.key === ".") &&
                              e.preventDefault()
                            }
                            style={{ fontFamily: "OpenSans-Regular" }}
                            type="number"
                            inputref={(ele) => (this.customersField = ele)}
                          />
                        </div>
                      </div>
                    </div>
                    <br />
                    <div className="input-margin flex input-space-between">
                      <div className="input-column-responsive">
                        <div className="appbar-div dual-margin ">
                          <div className="input-name input-responsive">
                            Correspondence Address*
                          </div>
                          <div style={{ marginTop: 10 }}>
                            <Input
                              name=""
                              onChange={this.handleChange("Address")}
                              placeholder="Enter Address"
                              value={this.state.Address.value}
                              isError={this.state.Address.isError}
                              onBlur={this.showError("Address")}
                              isShowError={this.state.Address.isError}
                              errorMessage={this.state.Address.errorMessage}
                              style={{ fontFamily: "OpenSans-Regular" }}
                            />
                          </div>
                        </div>
                        <div className="appbar-div dual-margin">
                          <div className="input-name input-responsive">
                            City*
                          </div>
                          <div style={{ marginTop: 10 }}>
                            <Input
                              name=""
                              onChange={this.handleChange("City")}
                              onBlur={this.showError("City")}
                              placeholder="Enter City"
                              value={this.state.City.value}
                              isError={this.state.City.isError}
                              isShowError={this.state.City.isError}
                              errorMessage={this.state.City.errorMessage}
                              style={{ fontFamily: "OpenSans-Regular" }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="input-column-responsive">
                        <div
                          className="appbar-div dual-margin "
                          style={{ marginTop: -15 }}
                        >
                          <div className="state-responsive input-responsive">
                            State*
                          </div>
                          <IntegrationReactSelect
                            suggestions={state.map((item) => ({
                              label: item[0],
                              value: item[1],
                            }))}
                            value={this.state.State.value}
                            label="State*"
                            placeholder="Select State"
                            isError={this.state.State.isError}
                            errorMessage={this.state.State.errorMessage}
                            handleChange={this.handleCStateSelect}
                          />
                        </div>
                        <div className="appbar-div dual-margin">
                          <div className="input-name input-responsive">
                            Pincode*
                          </div>
                          <div style={{ marginTop: 10 }}>
                            <Input
                              name=""
                              onChange={this.handleChange("Pincode")}
                              placeholder="Enter Pincode"
                              value={this.state.Pincode.value}
                              isError={this.state.Pincode.isError}
                              isShowError={this.state.Pincode.isError}
                              errorMessage={this.state.Pincode.errorMessage}
                              onBlur={this.showError("Pincode")}
                              onKeyDown={(e) =>
                                e.key === "Enter" && e.preventDefault()
                              }
                              style={{ fontFamily: "OpenSans-Regular" }}
                              type="number"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="dual-margin"
                      style={{ marginBottom: "10px", marginTop: "10px" }}
                    >
                      <input
                        type="checkbox"
                        style={{ display: "inline", marginRight: "10px" }}
                        onChange={(event) =>
                          event.target.checked
                            ? this.setState({
                                sameAddress: true,
                                Address2: { value: this.state.Address.value },
                                State2: { value: this.state.State.value },
                                City2: { value: this.state.City.value },
                                Pincode2: { value: this.state.Pincode.value },
                              })
                            : this.setState({
                                sameAddress: false,
                                Address2: { value: "" },
                                State2: { value: "" },
                                City2: { value: "" },
                                Pincode2: { value: "" },
                              })
                        }
                      />
                      {"Same as Correspondence Address"}
                    </div>
                    <div className="input-margin flex">
                      <div className="input-column-responsive">
                        <div className="appbar-div dual-margin ">
                          <div className="input-name input-responsive">
                            Registered Address
                          </div>
                          <div style={{ marginTop: 10 }}>
                            <Input
                              name=""
                              onChange={this.handleChange("Address2")}
                              placeholder="Enter  Address"
                              value={this.state.Address2.value}
                              onKeyDown={(e) =>
                                e.key === "Enter" && e.preventDefault()
                              }
                              style={{ fontFamily: "OpenSans-Regular" }}
                              disabled={this.state.sameAddress}
                            />
                          </div>
                        </div>
                        <div className="appbar-div dual-margin">
                          <div className="input-name input-responsive">
                            City
                          </div>
                          <div style={{ marginTop: 10 }}>
                            <Input
                              name=""
                              onChange={this.handleChange("City2")}
                              placeholder="Enter  City Name"
                              value={this.state.City2.value}
                              onKeyDown={(e) =>
                                e.key === "Enter" && e.preventDefault()
                              }
                              style={{ fontFamily: "OpenSans-Regular" }}
                              disabled={this.state.sameAddress}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="input-column-responsive">
                        <div
                          className="appbar-div dual-margin "
                          style={{ marginTop: -15 }}
                        >
                          <div
                            className="input-name input-responsive"
                            style={{ margiBottom: 0 }}
                          >
                            State
                          </div>
                          <IntegrationReactSelect
                            suggestions={state.map((item) => ({
                              label: item[0],
                              value: item[1],
                            }))}
                            value={this.state.State2.value}
                            label="Registered State"
                            placeholder="Select State"
                            handleChange={this.handleRStateSelect}
                            onKeyDown={(e) =>
                              e.key === "Enter" && e.preventDefault()
                            }
                            disabled={this.state.sameAddress}
                          />
                        </div>
                        <div className="appbar-div dual-margin">
                          <div className="input-name input-responsive">
                            Pincode
                          </div>
                          <div style={{ marginTop: 10 }}>
                            <Input
                              name=""
                              onChange={this.handleChange("Pincode2")}
                              placeholder="Enter Pincode"
                              value={this.state.Pincode2.value}
                              onKeyDown={(e) =>
                                e.key === "Enter" && e.preventDefault()
                              }
                              style={{ fontFamily: "OpenSans-Regular" }}
                              disabled={this.state.sameAddress}
                              type="number"
                              onBlur={this.showError("Pincode2")}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="digital-form-button-next-div">
                      <Signbutton
                        buttontitle="Save and Proceed"
                        onClick={this.submit}
                      />
                    </div>
                  </div>
                </div>
              </Paper>
            </React.Fragment>
          )}
      </div>
    );
  }
}
export default connect(
  ({ authReducer, npsReducer, profileReducer }) => {
    const { token, userId } = authReducer;
    const { Nps_Basic_Details } = npsReducer;
    const { profileData } = profileReducer;
    return {
      token,
      Nps_Basic_Details,
      userId,
      profileData,
    };
  },
  {
    checkEmpanelementStatus,
    getRejectionDetails,
    saveNpsBasicDetails,
    saveNpsBankDetails,
    saveRejectionDetails,
    getProfileData,
  }
)(NpsBasicDetails);
